import axios from "axios";

export default {
    async getUsers() {
        const response = await axios.get("rest/v1/search/users", {
            headers: {
                Authorization: process.env.VUE_APP_TOKEN,
            },
        });
        //console.log(response);
        return response.data.data;
    },

    async setPassword(dipendente_id, currentPassword, newPassword, confirmPassword) {
        const data = new FormData();
        data.append("dipendente_id", dipendente_id);
        data.append("current", currentPassword);
        data.append("new", newPassword);
        data.append("confirm", confirmPassword);

        //const response = await axios.post(`http://192.168.11.124/firegui_crm_h2/modulo-hr/app/cambiaPassword`, data, {
        const response = await axios.post(`${process.env.VUE_APP_BASE_URL}modulo-hr/app/cambiaPassword`, data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });

        return response;
    },

    async getVerificationCode(email) {
        const data = new FormData();
        data.append("email", email);

        const response = await axios.post("rest/v1/reset_password_request", data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        return response;
    },

    async changePassword(email, verificationCode, newPassword, confirmPassword) {
        const data = new FormData();
        data.append("email", email);
        data.append("verification_code", verificationCode);
        data.append("new_password", newPassword);
        data.append("confirm_new_password", confirmPassword);

        //const response = await axios.post(`http://192.168.11.124/firegui_crm_h2/modulo-hr/app/cambiaPassword`, data, {
            const response = await axios.post("rest/v1/reset_password_confirm", data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        return response;
    },
};
